import * as Yup from 'yup';

// Utils => Regex Patterns
import { EMAIL_REGEX, TEXT_REGEX, INDIA_PHONE_REGEX, GST_REGEX } from '../../utils/validations';

export const BillingDetailsValidationSchema = Yup.object().shape({
    isGstRegistered: Yup.boolean(),
    billingName: Yup.string().when('isGstRegistered', {
        is: false,
        then: (schema) =>
            schema.matches(TEXT_REGEX, 'Invalid Billing Name').required('Billing Name is required'),
        otherwise: (schema) => schema.nullable()
    }),
    companyName: Yup.string().when('isGstRegistered', {
        is: true,
        then: (schema) =>
            schema.matches(TEXT_REGEX, 'Invalid Company Name').required('Company Name is required'),
        otherwise: (schema) => schema.nullable()
    }),
    gstNumber: Yup.string().when('isGstRegistered', {
        is: true,
        then: (schema) =>
            schema.matches(GST_REGEX, 'Invalid GST Number').required('GST Number is required'),
        otherwise: (schema) => schema.nullable()
    }),
    email: Yup.string().when('isGstRegistered', {
        is: true,
        then: (schema) =>
            schema.matches(EMAIL_REGEX, 'Invalid Email').required('Email is required'),
        otherwise: (schema) => schema.nullable()
    }),
    phoneNumber: Yup.string().when('isGstRegistered', {
        is: true,
        then: (schema) =>
            schema
                .required('Phone Number is required')
                .test('phone-number', 'Invalid Phone Number', (value) => {
                    const isValidPhoneNumber = INDIA_PHONE_REGEX.test(value);
                    return isValidPhoneNumber;
                }),
        otherwise: (schema) => schema.nullable()
    }),
    address: Yup.string().when('isGstRegistered', {
        is: true,
        then: (schema) => schema.required('Address is required'),
        otherwise: (schema) => schema.nullable()
    }),
    city: Yup.string().when('isGstRegistered', {
        is: true,
        then: (schema) => schema.required('City is required'),
        otherwise: (schema) => schema.nullable()
    }),
    state: Yup.string().required('State is required'),
    termsAndConditions: Yup.boolean().oneOf([true], 'Please accept the terms and conditions')
});
